import React from 'react';
import { useGoogleOneTapLogin } from '@react-oauth/google';

interface GoogleAuthOneTapProps {
  onSuccess: (res: any) => void;
  onError?: () => void;
}

export default function GoogleAuthOneTap({ onSuccess, onError }: GoogleAuthOneTapProps) {
  useGoogleOneTapLogin({
    onSuccess,
    onError,
  });
  // No UI necessary—the prompt will show up automatically!
  return null;
}
